import { BaseCloseButton } from "./base-close-button"
import type { HeaderBaseProps } from "./factory-header.types"
import { SiteHeader } from "./site-header"

export function BaseHeader({ homePageLogoLink }: HeaderBaseProps) {
  return (
    <SiteHeader>
      {homePageLogoLink}
      <BaseCloseButton />
    </SiteHeader>
  )
}
